<template>
  <Modal
    v-model="show_asset"
    title="固定资产详情"
    ok-text="关闭"
    width="70%"
    cancel-text=""
  >
    <Row class="line">
      <i-col span="8">
        资产编号：{{ asset.uid }}
      </i-col>
      <i-col span="8">
        资产名称：{{ asset.asset_name.name }}
      </i-col>
      <i-col span="8">
        资产型号：{{ asset.asset_model }}
      </i-col>
    </Row>
    <Row class="line">
      <i-col span="8">
        所属公司：{{ companies_hash[asset.company_id] && companies_hash[asset.company_id].name }}
      </i-col>
      <i-col span="8">
        所属项目组：{{ teams_hash[asset.team_id] && teams_hash[asset.team_id].name }}
      </i-col>
      <i-col span="8">
        资产类型：{{ asset.asset_type && asset.asset_type.name }}
      </i-col>
      <!-- <i-col span="8">付款总金额：{{selected_expense_group.total_price}}</i-col>
          <i-col span="8">付款对象：{{selected_expense_group.payee_company}}</i-col> -->
    </Row>
    <Row class="line">
      <i-col span="8">
        设备类型：{{ asset.asset_device_type && asset.asset_device_type.name }}
      </i-col>
      <i-col span="8">
        设备品牌：{{ asset.asset_brand && asset.asset_brand.name }}
      </i-col>
      <i-col span="8">
        供应商：{{ asset.payee_company.name }}
      </i-col>
    </Row>
    <Row class="line">
      <i-col span="8">
        SN：{{ asset.sn }}
      </i-col>
      <i-col span="8">
        地点：{{ asset.asset_location && asset.asset_location.name }}
      </i-col>
      <i-col span="8">
        采购用途：{{ asset.purpose }}
      </i-col>
    </Row>
    <Row class="line">
      <i-col span="8">
        购入日期：{{ asset.purchase_date }}
      </i-col>
      <i-col span="8">
        购入价格：{{ asset.price }}
      </i-col>
      <i-col span="8">
        入账价格：{{ asset.in_price }}
      </i-col>
    </Row>
    <Row class="line">
      <i-col span="8">
        折旧年限：{{ asset.depreciation_year }}
      </i-col>
      <i-col span="8">
        资产残值：{{ asset.residual_value }}
      </i-col>
    </Row>
    <Row class="line">
      <i-col span="8">
        发票类型：{{ asset.invoice_type === 0 ? '普票' : '专票' }}
      </i-col>
      <i-col span="8">
        税额：{{ asset.tax_point }}
      </i-col>
    </Row>
    <Row class="line">
      <i-col span="8">
        预估税额：{{ asset.is_estimate_price ? '是' : '否' }}
      </i-col>
    </Row>
    <Row class="line">
      <i-col span="8">
        备注：{{ asset.desc }}
      </i-col>
    </Row>
  </Modal>
</template>
<script>
  import {mapGetters} from "vuex";

  export default {
    data() {
      return {
        show_asset: false,
        asset: {
          asset_name: {},
          asset_type: {},
          asset_device_type: {},
          asset_branch: {},
          payee_company: {},
          asset_location: {}
        }
      }
    },
    created() {
    },
    computed: {
      ...mapGetters({
        companies_hash: 'async/companies_hash',
        teams_hash: 'async/root_teams_hash',
      }),
    },
    methods: {
      show(asset_id) {
        this.show_asset = true
        this.$util.ajax(this.$util.api.asset_detail, {
          params: {
            id: asset_id
          }
        }).then(res => {
          return res.data
        }).then(res => {
          if (res.code === 1) {
            this.asset = res.data
          }
        })
      }
    },
  }
</script>
